module.exports = __webpack_public_path__ + "img/close.28526ee6.svg";